<template>
  <div class="media-input">
    <draggable
      v-model="items"
      v-if="items"
      @change="handleSort"
      @start="drag=true"
      @end="drag=false"
      class="media-input__list js-media-input-list"
    >
      <div
        class="media-input__item js-media-input-item js-media-item"
        v-for="item in items"
        :key="item.id"
        :data-item-id="item.id"
      >
        <img
          class="media-input__image img-fluid"
          :src="item.url"
          :alt="item.alt"
        >

        <button type="button" class="media-input__item-edit js-edit-media" @click="handleEdit(item.id)">
          <i class="fas fa-edit mr-1" aria-hidden="true"></i>Bewerken
        </button>

        <button type="button" class="media-input__item-delete" @click="handleDelete(item.id)">
          <i class="fas fa-times mr-1" aria-hidden="true"></i>
          <span class="sr-only">Verwijderen</span>
        </button>
      </div>
    </draggable>

    <div class="media-input__actions">
      <button class="media-input__add btn btn-secondary" type="button" @click="handleBrowserOpen">
        <i class="fas fa-plus" aria-hidden="true"></i>
        <span class="media-input__add-label ml-1">
          Afbeelding toevoegen
        </span>
      </button>
    </div>

    <input type="hidden" :name="name" :id="id" :value="ids" v-if="name">
  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  import uuidv4 from '../helpers/uuidv4';

  export default {
    props: {
      name: {
        type: String,
      },
      id: {
        default: 'media',
        type: String,
      },
      value: {
        default: '',
        type: [String, Array],
      },
    },

    components: {
      draggable,
    },

    data() {
      return {
        ids: [],
        items: [],
      };
    },

    created() {
      if (!this.value) {
        this.ids = [];
      } else if (Array.isArray(this.value)) {
        this.ids = this.value.map(item => item.id);
      } else {
        this.ids = this.value.split(',').map(item => parseInt(item, 10));
      }

      this.getMediaItems();
    },

    methods: {
      handleEdit(id) {
        // @todo Implement this instead of using the Media/Edit.js event listeners
      },

      handleDelete(id) {
        // Get all ids of the media items
        const ids = Array.prototype.slice.call(this.ids);

        // Remove the media item
        ids.splice(ids.indexOf(id), 1);

        // Overwrite ids to re-render
        this.ids = ids;

        this.$emit('update', this.ids);

        // Refetch media items from the server
        this.getMediaItems();
      },

      handleBrowserOpen() {
        const uuid = `widget:${uuidv4()}`;

        $(document).on('browser:selected', (e, obj) => {
          if (obj.id === uuid) {
            this.ids = this.ids.concat(obj.selected);

            this.$emit('update', this.ids);

            this.getMediaItems();
          }
        });

        $(document).trigger('browser:open', uuid);
      },

      handleSort() {
        this.ids = this.items.map(item => item.id);

        this.$emit('update', this.ids);
      },

      getMediaItems() {
        if (!this.ids.length) {
          this.items = [];

          return;
        }

        return window.axios.get(API.media.inputListUrl, {
          params: {
            ids: this.ids,
          },
        })
          .then((res) => {
            this.items = res.data;

            this.$emit('update', this.items.map(item => item.id));
          });
      },
    },
  };
</script>
